var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('progress-breakdown',{class:( _obj = {}, _obj['mb-3'] = !_vm.hideLegend, _obj ),attrs:{"progress-items":_vm.screeningProgressBreakdown,"height":_vm.height}}),(!_vm.hideLegend)?_c('screening-progress-legend',{attrs:{"legend-items":_vm.screeningProgressItems,"show-counts":_vm.hasReferences}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }